import React from 'react'
import {SearchBox as Search} from 'react-instantsearch-dom'
import WOW from 'react-wow'

import * as S from './styled'

const SearchBox = () => {
    return (
        <S.SearchBoxWrapper>
            <WOW animation="fadeInUp" data-wow-delay="0.3s">
                <S.SearchBoxTitle>Pesquisar</S.SearchBoxTitle>
            </WOW>
            <WOW animation="fadeInUp" data-wow-delay="0.3s">
                <Search
                    translations={{
                    placeholder: '🔍 Digite sua busca...'
                }}/>
            </WOW>
        </S.SearchBoxWrapper>
    )
}

export default SearchBox